'use client';

import { useRef } from 'react';

const useCloseAccount = () => {
  const backHandlerRef = useRef<(() => boolean) | null>(null);

  const handleBackNavigation = (onClose: () => void) => {
    if (backHandlerRef.current) {
      const handled = backHandlerRef.current();
      if (!handled) {
        // The handler returned false, meaning we should close the sheet
        onClose();
      }
    } else {
      // No handler registered, close the sheet
      onClose();
    }
  };

  const registerBackHandler = (handler: () => boolean) => {
    backHandlerRef.current = handler;
  };

  return {
    handleBackNavigation,
    registerBackHandler,
  };
};

export { useCloseAccount };
